import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import Layout from "./components/Layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { path } from "./navigation/path";
import { getRoutePermission } from "./utils/permission-map";
import Appartment from "./pages/appartment/Appartment";
import Audit from "./pages/audit/Audit";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import UpdatePassword from "./pages/auth/UpdatePassword";
import UserRegister from "./pages/auth/UserRegister";
import Blocks from "./pages/block/Blocks";
import Camera from "./pages/camera/Camera";
import Company from "./pages/company/Company";
import CompanyDetails from "./pages/company/CompanyDetails";
import Config from "./pages/config/Config";
import FamilyTree from "./pages/family/Family";
import FamilyList from "./pages/family/FamilyList";
import Marriage from "./pages/marriage/Marriage";
import Messaging from "./pages/messaging/Messaging";
import Node from "./pages/node/Node";
import Relationship from "./pages/relationship/Relationship";
import Request from "./pages/request/Request";
import StreamVehicle from "./pages/stream-vehicle/StreamVehicle";
import User from "./pages/user/User";
import UserDetails from "./pages/user/UserDetails";
import MyProfile from "./pages/user/MyProfile";
import Vehicle from "./pages/vehicle/Vehicle";
import Visitor from "./pages/visitor/Visitor";
import MessageStatus from "./pages/whatsapp/MessageStatus";
import Zone from "./pages/zone/Zone";

import Dashboard from "./pages/dashboard/Dashboard";
import NotImplementedPage from "./pages/not-implemented/NotImplementedPage";
import MessageTransactionsPage from "./pages/messaging/MessageTransactionsPage";
import MessageTransactionDetailPage from "./pages/messaging/MessageTransactionDetailPage";
import { TeamList } from "./pages/team/team-list";
import BibleVersesList from "./pages/bible-verse/bible-verse-list";
import { GroupList } from "./pages/group/group-list";
import LocationManagement from "./pages/location/LocationManagement";
import AnniversaryListPage from "./pages/messaging/AnniversaryListPage";
import MessagingEmergencyPage from "./pages/messaging/MessagingEmergency";
import { VisitorPage } from "./pages/new-visitor/VisitorPage";
import { VisitorDetails } from "./pages/new-visitor/VisitorDetails";
import { VisitorDashboard } from "./pages/new-visitor/VisitorDashboard";
import { VisitorFollowUpEdit } from "./pages/new-visitor/VisitorFollowUpEdit";
import BibleManagement from "./pages/bible-management/BibleManagement";
import BibleVerseOccasion from "./pages/bible-management/BibleVerseOccasion";
import RoleManagement from "./pages/role/RoleManagement";
import OccasionVerses from "./pages/bible-management/OccasionVerses";
import MasterData from "./pages/master-data/MasterData";
import CampusManagement from "./pages/campus/CampusManagement";
import NodeManagement from "./pages/campus/NodeManagement";
import NodeDetail from "./pages/campus/NodeDetail";
import VideoViewer from "./pages/video/VideoViewer";
import VehicleLogs from "./pages/vehicle-logs/VehicleLogs";
import VehicleLogsLive from "./pages/vehicle-logs/VehicleLogsLive";
import VehicleLogsHistory from "./pages/vehicle-logs/VehicleLogsHistory";
import VehicleLogsSearch from "./pages/vehicle-logs/VehicleLogsSearch";
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<Login />} path={path.LOGIN} />
          <Route element={<ForgotPassword />} path={path.FORGOT_PASSWORD} />
          <Route element={<UpdatePassword />} path={path.UPDATE_PASSWORD} />

          <Route element={<ProtectedRoute />} path="/">
            <Route element={<Layout />}>
              <Route element={<ProtectedRoute requiredPermission="dashboard.view" />}>
                <Route index element={<Dashboard />} path="/" />
              </Route>

              {/* Routes protected by permissions */}
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.USERS) || "user.manage"} excludeMemberBasedRoles={true} />}>
                <Route element={<UserRegister />} path={path.USERS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.CONFIG) || "config.manage"} />}>
                <Route element={<Config />} path={path.CONFIG} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.REQUESTS) || "request.manage"} />}>
                <Route element={<Request />} path={path.REQUESTS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.ZONES) || "zone.view"} />}>
                <Route element={<Zone />} path={path.ZONES} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.TEAMS) || "team.view"} />}>
                <Route element={<TeamList />} path={path.TEAMS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.GROUPS) || "group.view"} />}>
                <Route element={<GroupList />} path={path.GROUPS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.AUDIT) || "audit.view"} />}>
                <Route element={<Audit />} path={path.AUDIT} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.LOCATIONS) || "location.manage"} />}>
                <Route element={<LocationManagement />} path={path.LOCATIONS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.BIBLE_MANAGEMENT) || "bible.manage"} />}>
                <Route element={<BibleManagement />} path={path.BIBLE_MANAGEMENT} />
                <Route element={<BibleVerseOccasion />} path={path.BIBLE_VERSE_OCCASION} />
                <Route element={<OccasionVerses />} path={path.OCCASION_VERSES} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.ROLES) || "role.manage"} />}>
                <Route element={<RoleManagement />} path={path.ROLES} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={[0]} />}>
                <Route element={<MasterData />} path={path.MASTER_DATA} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission="campus.manage" />}>
                <Route element={<CampusManagement />} path={path.CAMPUSES} />
                <Route element={<NodeManagement />} path={path.CAMPUS_NODES} />
                <Route element={<NodeDetail />} path={path.CAMPUS_NODE_DETAIL} />
              </Route>

              {/* My Profile: any logged-in user with member_id (e.g. no-role users view own info) */}
              <Route element={<MyProfile />} path={path.MY_PROFILE} />
              {/* Other routes with permission protection */}
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.MEMBERS) || "member.view"} />}>
                <Route element={<User />} path={path.MEMBERS} />
                <Route element={<UserDetails />} path={path.MEMBER_DETAILS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.VEHICLES) || "vehicle.view"} />}>
                <Route element={<Vehicle />} path={path.VEHICLES} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.STREAM_VEHICLE) || "vehicle.stream"} />}>
                <Route element={<StreamVehicle />} path={path.STREAM_VEHICLE} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.VEHICLE_LOGS) || "vehicle.logs.view"} />}>
                <Route element={<VehicleLogs />} path={path.VEHICLE_LOGS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.VISITORS) || "visitor.view"} />}>
                <Route element={<VisitorDashboard />} path={path.VISITORS} />
                <Route element={<VisitorDetails />} path={path.VISITOR_DETAILS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.MESSAGING) || "messaging.compose"} />}>
                <Route element={<Messaging />} path={path.MESSAGING} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.MESSAGE_TRANSACTIONS) || "messaging.view"} />}>
                <Route element={<MessageTransactionsPage />} path={path.MESSAGE_TRANSACTIONS} />
                <Route element={<MessageTransactionDetailPage />} path={path.MESSAGE_TRANSACTION_DETAILS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.MESSAGE_ANNIVERSARIES) || "messaging.view"} />}>
                <Route element={<AnniversaryListPage />} path={path.MESSAGE_ANNIVERSARIES} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.CAMERAS) || "camera.manage"} />}>
                <Route element={<Camera />} path={path.CAMERAS} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={getRoutePermission(path.NODES) || "node.manage"} />}>
                <Route element={<Node />} path={path.NODES} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission="messaging.compose" />}>
                <Route element={<MessagingEmergencyPage />} path={path.MESSAGING_EMERGENCY_ALERT} />
              </Route>

              {/* Routes without specific permission requirements (legacy/fallback) */}
              <Route element={<Company />} path={path.COMPANIES} />
              <Route element={<CompanyDetails />} path={path.COMPANY_DETAILS} />
              <Route element={<MessageStatus />} path={path.MESSAGE_HISTORY} />
              <Route element={<Blocks />} path={path.BLOCK} />
              <Route element={<Appartment />} path={path.APPARTMENTS} />
              <Route element={<Marriage />} path={path.MARRIAGES} />
              <Route element={<Relationship />} path={path.RELATIONSHIPS} />
              <Route element={<FamilyTree />} path={path.FAMILY_TREE_VIEW} />
              <Route element={<FamilyList />} path={path.FAMILIES} />
              <Route element={<BibleVersesList />} path={path.BIBLE_VERSES} />
              <Route element={<BibleVersesList />} path={path.BIBLE_VERSES} />
              <Route element={<VideoViewer />} path={path.VISUALS} />
              <Route element={<VehicleLogsLive />} path={path.VEHICLE_LOGS_LIVE} />
              <Route element={<VehicleLogsHistory />} path={path.VEHICLE_LOGS_HISTORY} />
              <Route element={<VehicleLogsSearch />} path={path.VEHICLE_LOGS_SEARCH} />
              <Route element={<NotImplementedPage />} path={"*"} />
            </Route>
          </Route>
        </Routes>
      </Router>

      <ToastContainer position="bottom-right" />
    </div>
  );
}

export default App;
